export const RATING_SCALE_TABLE_ID = 'task-rating-scale-table';
export const RATING_SCALE_TABLE_HEADER_CELL_CLASS_NAME = 'task-rating-scale-table-header-cell';
